export const toRowField = (bucket, key) => `${key}_${bucket}`;

export const toBetaRowField = (bucket, key, betaKey) =>
  `${key}_${bucket}_${betaKey}`;

export const toFaRowField = (bucket, key, faKey) => `${key}_${bucket}_${faKey}`;

export const toColId = (pivotDefinition, bucket) => {
  const { levels, analytics, filterDefinitions, summary, lookthru } =
    pivotDefinition;
  let base = `${levels}, ${analytics}, ${bucket}, ${summary}`;
  if (filterDefinitions.length > 0) {
    base = `${base}, ${filterDefinitions.map(({ key }) => key).join(", ")}`;
  }
  if (!lookthru) {
    base += ", non-lookthru";
  }

  return base;
};
